import Header from "@/atomic/atoms/Header";
import OrgPayment from "@/atomic/organisms/orgPayment";
import { PropsView } from "./Models";

export default function CheckoutView({
  goToCard,
  goToPix,
  goBack,
  plate,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Pagamento"
        goBack={goBack}
        hasLeftButton
      />
      <main className="p-2 w-full flex justify-center text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="text-2xl mt-4">Forma de pagamento</h2>
            <h3 className="text-sm mt-1">Selecione abaixo como quer fazer o pagamento</h3>
            <button type="submit" onClick={goToCard} className="w-full flex justify-between items-center mt-5 text-start">
              <div className="flex items-center">
                <img 
                  src={process.env.PUBLIC_URL +"/icon-credit-card.png"}
                  width={40}
                  height={40}
                  alt="Card credit icon"
                />
                <div className="ml-3">
                  <p className="text-base">Cartão de crédito</p>
                  <p className="text-xs">Informações do seu cartão</p>
                </div>
              </div>
              <img 
                src={process.env.PUBLIC_URL +"/arrow-right.png"}
                width={24}
                height={24}
                alt="escolher cartão"
              />
            </button>
            <div className="w-full h-px bg-slate-300 mt-4 mb-4" />
            <button type="submit" onClick={goToPix} className="w-full flex justify-between items-center text-start">
              <div className="flex items-center">
                <img 
                  src={process.env.PUBLIC_URL +"/icon-pix.png"}
                  width={40}
                  height={40}
                  alt="pix icon"
                />
                <div className="ml-3">
                  <p className="text-base">Pix</p>
                  <p className="text-xs">Informações para pagamento</p>
                </div>
              </div>
              <img 
                src={process.env.PUBLIC_URL +"/arrow-right.png"}
                width={24}
                height={24}
                alt="escolher pix"
              />
            </button>
          </div>
          <OrgPayment 
            plate={plate}
            disabled
          />
        </article>
      </main>
    </div>
  );
}
